import "unfetch/polyfill";

export default function findConfig(apiUrl, apiKey) {
  return new Promise(function(resolve, reject) {
    fetch(apiUrl + "config?apiKey=" + apiKey)
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
